<!-- 推送服务 -->
<template>
  <div class="shell">
    <div class="boxLeft">
      <ul class="left">
        <!-- <li>类型</li> -->
        <li
          v-for="(item, index) in typeData"
          :key="index"
          @click="change(index)"
          :class="couponType == index ? 'current' : 'original'"
        >
          {{ item.name }}
        </li>
      </ul>
    </div>
    <div class="boxRight">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      typeData: [
        // {
        //   name: "模板消息推送",
        //   index: 0,
        //   path: "activeIndex"
        // },
        {
          name: "活跃粉丝推送",
          index: 0,
          path: "activeIndex"
        },
        {
          name: "智能推送",
          index: 1,
          path: "smartIndex"
        },
        {
          name: "资源库管理",
          index: 2,
          path: "resource"
        }
      ],
      couponType: "0"
    };
  },

  components: {},
  mounted() {
    if (this.$route.query.present) this.couponType = this.$route.query.present;
  },
  methods: {
    change(index) {
      this.$nextTick(function() {
        let url = this.typeData[index].path;
        this.$router.push(url + "?present=" + index);
      });
      console.log("侧边栏", this.couponType, index);
    }
  }
};
</script>
<style lang="scss" scoped>
.shell {
  width: 100%;
  height: 100%;
  display: flex;
  .boxLeft {
    min-width: 200px;
    height: 100%;
    margin-right: 15px;
    border: 1px solid #ebeef5;

    li {
      width: 100%;
      line-height: 50px;
      padding: 0 15px;
      // border-bottom: 1px solid #ebeef5;
      cursor: pointer;
      background: #fff;
    }

    .original {
      background: #fff;
    }
    .current {
      background: #fafafa;
    }
  }
  .boxRight {
    flex: 1;
  }
}
</style>
